import { render } from "./GameNotice.vue?vue&type=template&id=22bd96ce&scoped=true"
import script from "./GameNotice.vue?vue&type=script&lang=ts"
export * from "./GameNotice.vue?vue&type=script&lang=ts"

import "./GameNotice.vue?vue&type=style&index=0&id=22bd96ce&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-22bd96ce"

export default script